import React, {useEffect } from "react";
import ReactGA from "react-ga4";

const PageTracking = (props) => {
  const {page} = props

  useEffect(() => {
    ReactGA.initialize("G-9NYLKG93MZ");
    ReactGA.send({
      hitType: "pageview",
      page: page,
    });
  }, []);

  return (
      <></>
    );
  };
  
  export default PageTracking;